/// <reference path="../../../api/apps/typings/customTds.d.ts"/>


export class BasicApplicationService<T extends BasicAppDefinition> {

	private readonly options: BasicAppOptions<T>;

	constructor(options: BasicAppOptions<T>) {
		this.options = options;
	}

	private getStep(): number {
		return this.options.app.currenttemplate.step;
	}

	public getCurrentStepName(): string {
		let result = "";
		if (this.options.app.templates) {
			const i = this.getStep();
			for (const k in this.options.app.templates) {
				if (this.options.app.templates[k] && this.options.app.templates[k].step === i) {
					result = k;
					break;
				}
			}
		}
		return result;
	}

	public isStep(step: number): boolean {
		return this.options.app.currenttemplate.step === step;
	}

	public shallowCopyOptions(): BasicAppOptions<T> {
		const tmpctx = this.options.$ctx;
		const tmpvalrules = this.options.app.validatorRules;
		this.options.$ctx = null;
		this.options.app.validatorRules = null as unknown as ValidationRules;

		const result: BasicAppOptions<T> = JSON.parse(JSON.stringify(this.options));
		this.options.$ctx = tmpctx;
		this.options.app.validatorRules = tmpvalrules;
		result.$ctx = tmpctx;
		result.app.validatorRules = tmpvalrules;

		return result;
	}

	public preparePageOptions(pagekey: string): BasicAppOptions<T> {
		// copy options and manually update the currenttemplate to the template at pagekey
		const result = this.shallowCopyOptions();
		result.app.currenttemplate.templateurl = result.app.templates[pagekey].templateurl;
		result.app.currenttemplate.step = result.app.templates[pagekey].step;
		return result;
	}

	hasSubApps(subapps: any, contentId?: string): boolean {
		if (contentId) {
			return subapps.some((subapp: any) => subapp.contentid === contentId && subapps?.length > 0);
		} else {
			return subapps?.length > 0;
		}
	}

}
